import { render, staticRenderFns } from "./notice-edit.vue?vue&type=template&id=b7a51ce2&scoped=true"
import script from "./notice-edit.vue?vue&type=script&lang=js"
export * from "./notice-edit.vue?vue&type=script&lang=js"
import style0 from "./notice-edit.vue?vue&type=style&index=0&id=b7a51ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a51ce2",
  null
  
)

export default component.exports